export default __webpack_public_path__ + "static/popup.dark-9e79bd7f48465aea26d95fc661f6aac76815fa4d6bb8c1b45af63bb280860847.png";